import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import { FormControl, StepInput } from 'components/common/forms';
import { VisitorsInfo } from 'interfaces/ReservationSubTypes';
import KeyCode from 'rc-util/lib/KeyCode';
import styled from '@emotion/styled';

interface Props {
  value?: VisitorsInfo
  disabled?: boolean;
  onChange?: (value: VisitorsInfo) => void;
}
const GuestDropdown: React.FC<Props> = ({ value, disabled, onChange }) => {
  const [form] = Form.useForm<VisitorsInfo>();
  const [isOpen, setIsOpen] = useState(false);
  value = value || {
    adults: 0, children: 0, pets: 0
  };

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue(value);
    }
  }, [form, isOpen, value]);

  const overlay = () => (
    <Overlay>
      <Form form={form}
        initialValues={value}
        layout="horizontal"
        labelCol={{ flex: `0 0 ${10/24 * 100}%` }}
        wrapperCol={{ flex: `0 0 ${10/24 * 100}%` }}
        autoComplete="off"
        onKeyDown={onKeyDown}
      >
        <FormControl name="adults" label="Adults">
          <StepInput min={0} max={10} />
        </FormControl>
        <FormControl name="children" label="Children">
          <StepInput min={0} max={10} />
        </FormControl>
        <FormControl name="pets" label="Pets">
          <StepInput min={0} max={10} />
        </FormControl>
      </Form>
    </Overlay>
  );

  const onKeyDown = (ev: React.KeyboardEvent<HTMLFormElement>) => {
    if (ev.keyCode === KeyCode.ESC) {
      ev.stopPropagation();
    }
  };

  const onDropdownVisibleChange = (open: boolean) => {
    setIsOpen(open);
    if (!open) {
      const values = form.getFieldsValue();
      values.adults = Number(values.adults);
      values.children = Number(values.children);
      values.pets = Number(values.pets);
      onChange && onChange(values);
    }
  };

  const placeholder = isOpen ?
    'Fill Adults, Children and Pets' :
    `${value.adults} Adults, ${value.children} Children, ${value.pets} Pets`;

  return (
    <StyledSelect placeholder={placeholder} className="form-select"
      disabled={disabled}
      style={{width: '100%'}}
      dropdownRender={overlay} 
      dropdownStyle={{padding: 0}}
      dropdownMatchSelectWidth={false}
      onDropdownVisibleChange={onDropdownVisibleChange}
    />
  );
};

const StyledSelect = styled(Select)`
  & .ant-select-selection-placeholder {
    color: rgba(0, 0, 0, 0.85);
  }
`;

const Overlay = styled.div`
  width: 100%;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 12px 24px 0;
  .ant-form-item {
    flex-direction: row;
    margin-bottom: 12px;
    justify-content: space-between;
  }
  .ant-form-item-label {
    padding: 0;
    text-align: left;
  }
`;

export default GuestDropdown;
